<script>
    import {Line} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Line,
        mounted() {
            this.renderChart(
                {
                    labels: ['2016', '2017', '2018'],
                    datasets: [
                        {
                            label: 'TOTAL INVERSIÓN SOCIAL (USD)',
                            backgroundColor: hexToRgba('#00bdff', 70),
                            fill: true,
                            data: ['', '', 135295]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                        }]
                    },
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
